import {Component, Input, inject} from '@angular/core';
import { CommonModule } from '@angular/common';
import {BaseComponent} from "@wms/components";
import {TooltipModule} from "ngx-bootstrap/tooltip";
import {
  RoleSelectorComponent
} from "@wms/app/properties-panel/properties-template/components/role-selector/role-selector.component";
import { LiveWidgetSettingsService } from '@wms/app/services/liveWidgetsSettings/live-widget-settings.service';
import { onAccessRolesChange } from '@wms/app/core';

@Component({
  selector: 'wms-security',
  standalone: true,
  imports: [CommonModule, TooltipModule, RoleSelectorComponent],
  templateUrl: './security.component.html',
  styleUrls: ['./security.component.less']
})
export class SecurityComponent extends BaseComponent{
  @Input() liveWidgetSettings: LiveWidgetSettingsService;
  constructor() {
    super();
  }

  onModelChange($event : any) : void {
    const value = onAccessRolesChange('accessroles', $event); 
    if (this.liveWidgetSettings.activeTab.type === 'actions') {
      this.liveWidgetSettings.selectedComponent.button.accessroles = value;
    } else {
      this.liveWidgetSettings.selectedComponent.field.accessroles = value;
    }
  }
}
